<template>
  <div
    class="
      cbg-white-container
      input-container
      theme--light
      v-card
      p-16
      border-card
    "
  >
    <v-row>
      <v-col cols="12" md="3">
        <label for>Search by Saathi Code</label>
        <input
          class="form-control"
          v-model="saathiCode"
          placeholder="Saathi code"
          @input="debounceSearch()"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div class="table-div overflow-auto">
          <table class="table userlistTable">
            <thead>
              <tr class="table-success">
                <th>DocSmart user name</th>
                <th>DocSmart user number</th>
                <th>Role</th>
                <th>Saathi Code</th>
                <th>Subscription details</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="subscription in subscriptions" :key="subscription._id">
                <td>{{ subscription.user.full_name }}</td>
                <td>{{ subscription.user.mobile }}</td>
                <td>{{ subscription.role }}</td>
                <td>{{ subscription.seva_record.saathi_code }}</td>
                <th>
                  <a @click="showSubscriptionDetails(subscription)">View</a>
                </th>
              </tr>
            </tbody>
          </table>
        </div>
      </v-col>
    </v-row>
    <pagination
      v-if="!isEmpty"
      class="mx-6"
      :currentPage="page"
      :recordPerPage="recordsPerPage"
      :total="total"
      @changePage="changePage"
    />
    <v-dialog
      persistent
      v-if="showSubscriptionDetailsModal"
      v-model="showSubscriptionDetailsModal"
      width="400"
    >
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Subscription details
        </v-card-title>
        <v-card-text>
          <v-row class="mx-0 mt-0">
            <p class="mb-0 mr-2 font-weight-bold">Subscription plan name :</p>
            <p>{{ subscriptionDetail.name }}</p>
          </v-row>
          <v-row class="mx-0">
            <p class="mb-0 mr-2 font-weight-bold">Tenure :</p>
            <p>{{ subscriptionDetail.validity_text }}</p>
          </v-row>
          <v-row class="mx-0">
            <p class="mb-0 mr-2 font-weight-bold">Validity :</p>
            <p>
              {{ getDate(subscriptionDetail.activation_date) }} -
              {{ getDate(subscriptionDetail.expiration_date) }}
            </p>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="showSubscriptionDetailsModal = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import config from "@/config.js";
import debounce from "lodash/debounce";
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();
export default {
  data() {
    return {
      dayJS,
      subscriptions: [],
      role: "doctor",
      saathiCode: null,
      page: 1,
      recordsPerPage: 10,
      total: 0,
      isEmpty: true,
      showSubscriptionDetailsModal: false,
      subscriptionDetail: null,
    };
  },
  components: {
    pagination: () => import("@/views/common/Pagination"),
  },
  methods: {
    getDate(date) {
      return dayJS(date).format("DD/MM/YYYY");
    },
    debounceSearch: debounce(function () {
      this.isEmpty = true;
      this.getSubscriptons();
    }, 500),
    changePage(page) {
      this.page = page.currentPage;
      this.getSubscriptons();
    },
    onChangeRole() {
      this.page = 1;
      this.getSubscriptons();
    },
    getSubscriptons() {
      let params = {
        saathi_code: this.saathiCode,
        role: this.role,
        records_per_page: this.recordsPerPage,
        page: this.page,
      };
      let url = `${config.BASE_URL}api/v2/admin/seva/subscription-via-docsmart`;
      this.$http.get(url, { params }).then((response) => {
        if (response.body.status) {
          if (response.body.data.total > 0) this.isEmpty = false;
          else this.isEmpty = true;
          this.page = response.body.data.page;
          this.recordsPerPage = response.body.data.limit;
          this.total = response.body.data.count;
          this.subscriptions = response.body.data.list;
        }
      });
    },
    showSubscriptionDetails(subscription) {
      this.subscriptionDetail = subscription;
      this.showSubscriptionDetailsModal = true;
    },
  },
  mounted() {
    this.getSubscriptons();
  },
};
</script>
